import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layoutServices"
import SEO from "../components/seo"

import "../styles/global.css"

const ServicesPage = () => (
  <>
  <SEO title="Osobná Značka a Marketing pre Freelancerov" keywords={[`online bodyguard, tatransky marketing, tatransky branding, celebrity branding, online reputacia`]} />
  <Layout />
  </>
)

export default ServicesPage
